export default "__VITE_ASSET__DUX7q3sl__"